import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

const TermsOfService = () => {
  useEffect(() => {
    document.title = 'Kullanım Şartları | akarma';
  }, []);

  return (
    <div className="terms-of-service pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <FileText size={64} className="mx-auto mb-6" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Kullanım Şartları</h1>
            <p className="text-xl opacity-90">akarma.com.tr web sitesi kullanım koşulları</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 mb-8">
                Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900">1. Genel Hükümler</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                akarma.com.tr web sitesini (bundan böyle "Site" olarak anılacaktır) ziyaret ederek ve/veya kullanarak, 
                işbu Kullanım Şartları'nı okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site, Banu Gökcül tarafından işletilmektedir ve eğitim, koçluk, danışmanlık hizmetleri hakkında 
                bilgi sağlamak amacıyla oluşturulmuştur.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">2. Hizmetler</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Site üzerinden aşağıdaki hizmetler hakkında bilgi edinebilirsiniz:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>Bireysel koçluk ve danışmanlık hizmetleri</li>
                <li>Kurumsal eğitim programları</li>
                <li>Motivasyon konuşmaları</li>
                <li>NLP (Nöro-Linguistik Programlama) terapisi</li>
                <li>Kişisel gelişim eğitimleri</li>
                <li>Kitap ve yayınlar</li>
              </ul>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">3. Kullanım Koşulları</h2>
              <h3 className="text-2xl font-semibold mb-4 text-gray-800">3.1. Yasal Kullanım</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site'yi yalnızca yasal amaçlar için kullanmayı kabul edersiniz. Aşağıdaki faaliyetler yasaktır:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>Site'nin güvenliğini tehdit edecek herhangi bir eylem</li>
                <li>Başkalarının haklarını ihlal eden içerik paylaşımı</li>
                <li>Spam, virüs veya zararlı yazılım dağıtımı</li>
                <li>Site içeriğinin izinsiz kopyalanması veya çoğaltılması</li>
                <li>Otomatik sistemler veya botlar kullanarak Site'ye erişim</li>
              </ul>

              <h3 className="text-2xl font-semibold mb-4 text-gray-800 mt-8">3.2. İçerik Kullanımı</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site'de yer alan tüm içerik (yazılar, makaleler, görseller, videolar, logolar) telif hakkı ile 
                korunmaktadır. İçeriklerin izinsiz kullanımı, kopyalanması veya dağıtılması yasaktır.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">4. Fikri Mülkiyet Hakları</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site'de yer alan tüm içerik, tasarım, logo, grafik, yazılım ve diğer materyaller akarma'nın ve/veya 
                lisans verenlerin fikri mülkiyetidir. Bu haklar uluslararası telif hakkı yasaları ile korunmaktadır.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                "akarma", "Kuantum Sıçrama için Ayna Tekniği" ve diğer markalar akarma'nın tescilli markalarıdır.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">5. Gizlilik</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Kişisel verilerinizin işlenmesi ve korunması hakkında detaylı bilgi için lütfen{' '}
                <Link to="/gizlilik" className="text-akarma-blue hover:underline font-semibold">
                  Gizlilik Politikası
                </Link>{' '}
                sayfamızı inceleyin.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">6. İletişim Formu ve Randevu</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site üzerinden gönderdiğiniz iletişim formları ve randevu talepleri, hizmet sunumu amacıyla 
                değerlendirilecektir. Gönderdiğiniz bilgilerin doğru ve güncel olmasından siz sorumlusunuz.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">7. Sorumluluk Reddi</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site'de yer alan bilgiler genel bilgilendirme amaçlıdır ve profesyonel danışmanlık hizmeti yerine 
                geçmez. Bireysel durumunuz için mutlaka uzman bir danışman ile görüşmeniz önerilir.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                akarma, Site'nin kesintisiz ve hatasız çalışacağını garanti etmez. Site kullanımından kaynaklanan 
                doğrudan veya dolaylı zararlardan sorumlu tutulamaz.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">8. Üçüncü Taraf Bağlantılar</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site, üçüncü taraf web sitelerine bağlantılar içerebilir. Bu bağlantılar yalnızca kolaylık sağlamak 
                amacıyla verilmiştir. akarma, bu sitelerin içeriğinden veya gizlilik uygulamalarından sorumlu değildir.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">9. Değişiklikler</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                akarma, bu Kullanım Şartları'nı dilediği zaman değiştirme hakkını saklı tutar. Değişiklikler Site'de 
                yayınlandığı anda yürürlüğe girer. Site'yi kullanmaya devam ederek, güncellenmiş şartları kabul etmiş sayılırsınız.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">10. Uygulanacak Hukuk</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Bu Kullanım Şartları, Türkiye Cumhuriyeti yasalarına tabi olacaktır. Bu Şartlar'dan kaynaklanan 
                uyuşmazlıkların çözümünde İstanbul Mahkemeleri ve İcra Daireleri yetkili olacaktır.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">11. İletişim</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Kullanım Şartları hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
              <div className="bg-gray-50 p-6 rounded-xl mb-6">
                <p className="text-gray-700 mb-2">
                  <strong>E-posta:</strong> info@akarma.com.tr
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Telefon:</strong> +90 212 263 3484
                </p>
                <p className="text-gray-700">
                  <strong>Adres:</strong> Etiler Mahallesi Uçaksavar Sitesi Muharipler Sokak No:9 D:2, Etiler / Beşiktaş / İstanbul
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-12 text-center">
              <Link
                to="/iletisim"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
              >
                Bizimle İletişime Geçin
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;